import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
import s from './InvoicePopup.module.css';
import VeryLightGreenButton from '../../Components/Buttons/VeryLightGreenButton';
import ModalWrapper from '../../Components/ModalWrapper/ModalWrapper';

import {
	useGetBalanceApproveMutation,
	useGetBalanceProductsQuery,
} from '../../redux/DepotSlice/depotReportApi';
import {
	ProductInReportType,
	RequestApproveProductsType,
} from '../../types/TypesStore';
import {handleApiCall} from '../../assets/utils/utils';
import ConfirmationTableRowItem from './ConfirmationTableRowItem';
import PreLoaderComponent from '../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import {useTranslation} from 'react-i18next';
import GridTableHead from '../../Components/GridTableHead/GridTableHead';
import EasyGreenCheckBox from '../../Components/CustomCheckbox/EasyGreenCheckBox';

const ConfirmationOfReceipt = () => {
	const {t} = useTranslation();
	const session = useSelector((state: RootState) => state.appData.session);
	const authData = useSelector((state: RootState) => state.userData.authData);
	
	// Получаем role_id из session или authData
	const roleId = session.role_id ?? authData.role_id ?? null;
	
	// Попап только для складов (role_id === 3)
	const isWarehouse = roleId === 3;
	
	const [open, setOpen] = useState(false);
	const [checkedList, setCheckedList] = useState<ProductInReportType[] | []>(
		[],
	);
	const [approve] = useGetBalanceApproveMutation();
	const {data, isLoading} = useGetBalanceProductsQuery(undefined, {
		skip: !isWarehouse, // Не делаем запрос, если не склад
	});

	useEffect(() => {
		// Не показываем попап, если не склад
		if (!isWarehouse) return;

		const now = new Date();
		const month = now.getMonth(); // 0-11
		const year = now.getFullYear();

		const key = `${year}-${month}`;
		const lastConfirmed = localStorage.getItem('lastConfirmedMonth');
		const dismissCount = Number(localStorage.getItem('dismissCount') || '0');

		// Якщо вже підтвердив цього місяця
		if (lastConfirmed === key) return;

		// Якщо ще не підтвердив
		if (!lastConfirmed || lastConfirmed !== key) {
			// Якщо ще не було закриттів — показуємо
			if (dismissCount === 0) {
				setOpen(true);
			} else {
				// Якщо закривав — показувати кожне друге завантаження
				if (dismissCount % 2 === 1) {
					setOpen(true);
				}
			}
			localStorage.setItem('dismissCount', String(dismissCount + 1));
		}
	}, [isWarehouse]);
	const handleChangeAll = () => {
		if (checkedList.length === data?.products?.length) {
			// уже всё выбрано → снимаем выделение
			setCheckedList([]);
		} else {
			// выбираем всё
			setCheckedList(data?.products || []);
		}
	};
	const handleConfirm = async () => {
		const data: RequestApproveProductsType = {
			approve: true,
			approve_product: checkedList,
		};
		await handleApiCall({
			apiCall: () => approve(data),
			onSuccess: () => {
				const now = new Date();
				const key = `${now.getFullYear()}-${now.getMonth()}`;
				localStorage.setItem('lastConfirmedMonth', key);
				localStorage.setItem('dismissCount', '0'); // скидаємо
				setOpen(false);
			},
		});
	};
	const handleClose = () => {
		setOpen(false);
	};
	
	// Не рендерим компонент, если не склад
	if (!isWarehouse) {
		return null;
	}
	
	if (open) {
		return (
			<ModalWrapper handleClosePopup={handleClose}>
				<div className={`${s.container}`}>
						<div className={s.title}>
							<h4>{t('Підтвердження залишків продукції на складі')}</h4>
							{/*<div className={s.subTitle}>НАКЛАДНАЯ №123456</div>*/}
						</div>
						{/*<div className={s.searchWrapper}>
									<SearchWindow />
								</div>*/}
						<div className={s.tableWrapper}>
							{isLoading ? (
								<PreLoaderComponent type={'circle'} size={'big'} />
							) : (
								data && (
									<div className={s.tableGrid}>
										<GridTableHead 
											columns={['', t('Назва'), t('Кількість')]} 
											gridTemplateColumns="1fr 1fr 2fr"
											customClassName={s.confirmationTableHead}
										/>
										{data.products?.map((product: ProductInReportType) => (
											<ConfirmationTableRowItem
												key={product.product_id}
												product={product}
											/>
										))}
									</div>
								)
							)}
						</div>
						<div className={s.tableColumn}>
							<EasyGreenCheckBox
								id={'all'}
								checked={checkedList.length === data?.products?.length}
								label={t('Я підтверджую, що залишки збігаються')}
								handleChange={handleChangeAll}
							/>
						</div>
						<div className={s.buttonsWrapper}>
							{/*<LightGreenButton text={'подтвердить и вернуть недостачу'} />*/}
							<VeryLightGreenButton
								text={t('Підтвердити')}
								onClick={handleConfirm}
							/>
						</div>
					</div>
			</ModalWrapper>
		);
	} else return null;
};

export default ConfirmationOfReceipt;
